// extracted by mini-css-extract-plugin
export default {"ResultsCount":"ResultsCount_ResultsCount__N7PiW","staticText":"ResultsCount_staticText__a1Aqu"};